import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=c31f0426&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=c31f0426&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31f0426",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c31f0426')) {
      api.createRecord('c31f0426', component.options)
    } else {
      api.reload('c31f0426', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=c31f0426&scoped=true&", function () {
      api.rerender('c31f0426', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4v7EtJXvl4QHn/JS/comp/GuestBox.vue"
export default component.exports